import React from 'react'
import {Link} from 'react-router-dom'
import '../CSS/MovieThumb.css'
const MovieThumb = (props) => {
    return (
        <div className="rmdb-moviethumb">
            {props.clickable ?
                <Link to ={{pathname: `/${props.movieId}` , movieName: `${props.movieName}`}}>
                    <img src={props.image} alt="Movie Thumb" />  
                </Link>
                : 
                <img src={props.image} alt="Movie Thumb" />  
            }
        </div>
    )
}

export default MovieThumb
